import React, { Suspense, lazy, useEffect, useState } from 'react';
import { onToastWanted, toasterReady } from '../lib/toast';

// R6 — the toaster (sonner) mounts once the page has loaded and the browser is idle,
// or right away when something wants to show a toast.
const Ready = ({ t }) => {
  useEffect(() => { toasterReady(t); }, [t]);
  return null;
};

const SonnerToaster = lazy(() => import('./ui/sonner').then(({ Toaster: Sonner, toast }) => ({
  default: (props) => (
    <>
      <Sonner {...props} />
      <Ready t={toast} />
    </>
  ),
})));

export const LazyToaster = (props) => {
  const [on, setOn] = useState(false);
  useEffect(() => {
    onToastWanted(() => setOn(true));
    const idle = window.requestIdleCallback || ((f) => setTimeout(f, 1500));
    const start = () => idle(() => setOn(true), { timeout: 4000 });
    if (document.readyState === 'complete') start();
    else window.addEventListener('load', start, { once: true });
  }, []);
  if (!on) return null;
  return (
    <Suspense fallback={null}>
      <SonnerToaster {...props} />
    </Suspense>
  );
};

export default LazyToaster;
